import { render, staticRenderFns } from "./auto.vue?vue&type=template&id=babc7af0&scoped=true"
import script from "./auto.vue?vue&type=script&lang=js"
export * from "./auto.vue?vue&type=script&lang=js"
import style0 from "./auto.vue?vue&type=style&index=0&id=babc7af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babc7af0",
  null
  
)

export default component.exports